const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/blog/new.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/blog/new")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/* ─── Helpers ─── */